import haileysbot from "../assets/img/past_projects/haileysbot.PNG";
import Chat_RNC from "../assets/img/past_projects/React_Nodejs_CHAT_1.jpg";
import flappy from "../assets/img/past_projects/flappy.png";
import RapNow from "../assets/img/past_projects/rapNow01.PNG";
import Op from "../assets/img/past_projects/triplanarmap-ope-ope.png";
import Armo from "../assets/img/past_projects/armo-bldr-forest.png";
import Dune from "../assets/img/past_projects/arrakis.png";
import Golf from "../assets/img/past_projects/m-golf.png";
import X410 from "../assets/img/past_projects/selected-3d-viewer.png";
import lava from "../assets/img/past_projects/lava-shader.png";
import interactiveVid from "../assets/img/past_projects/interactive-video.png";
import prodComp from "../assets/img/past_projects/product-comp-table.png";

export const graphicsProjects = [
  {
    title: "M-Golf",
    description:
      "M-Golf ⛳️ is a small but not so 'mini' golf game! Trick shots, long drives, pitching, do it all! Built with Blender, Three.js, GLSL and Rapier Physics.",
    imageUrl: Golf,
    url: "https://m-golf.pages.dev",
  },
  {
    title: "Brik Builder",
    description:
      "Fun voxel based builder with robust spatial validation for placing onto the grid and on to other bricks. Inspired by Bricklink Studio.",
    imageUrl: Armo,
    url: "https://armo-bldr.pages.dev/",
  },
  {
    title: "CBW - 3D Interactive Viewer",
    description:
      "X-410 Controller Product Visualization utilizing 2D-in-3D elements for annotations. This software is owned by ControlByWeb LLC.",
    imageUrl: X410,
    url: "https://controlbyweb.com/",
  },
  {
    title: "Devil Fruit",
    description:
      "OnePiece Ope Ope No Mi tribute GLSL raymarching shader. Lambertian diffuse lighting and custom tri-planar mapping.",
    imageUrl: Op,
    url: "https://www.shadertoy.com/view/scf3Wf",
  },
  {
    title: "Lava Shader",
    description:
      "This GLSL lava shader uses FBM and Perlin cnoise to create this nice layered noise displacement in the vertex shader and gradient in the fragment shader.",
    imageUrl: lava,
    url: "https://codepen.io/anthony-eng21/pen/MYeLzJm",
  },
  {
    title: "2D 'Dune' Shader",
    description:
      "This GLSL shader was inspired by Frank Herbert's Dune. I love the book series and decided to make a tribute.",
    imageUrl: Dune,
    url: "https://www.shadertoy.com/view/W3VBRh",
  },
  {
    title: "Flappy Bird Clone",
    description:
      "Made with WebGL, this was apart of an old assignment from school where I had to create the collision detection and game loop.",
    imageUrl: flappy,
    url: "https://flappy-bread-git-main-anthony-eng21.vercel.app/",
  },
];
export const webProjects = [
  {
    title: "CBW - Interactive Video",
    description:
      'This is a "step-by-step" video experience with scheduling for pauses and in-video dialogs. This software is owned by ControlByWeb LLC.',
    imageUrl: interactiveVid,
    url: "https://controlbyweb.com/",
  },
  {
    title: "CBW - Product Comparison",
    description:
      "Product Comparison Table allows the user to compare specs/attributes of selected products. This software is owned by ControlByWeb LLC.",
    imageUrl: prodComp,
    url: "https://controlbyweb.com/",
  },
  {
    title: "Real Time Messaging App",
    description:
      "Create groups and talk with your friends. Built in with a MERN stack and with the flexible Chat Engine library.",
    imageUrl: Chat_RNC,
  },
];

export const mobileProjects = [
  {
    title: "Hailey's Bot",
    description:
      "Nice AI chat bot experience developed with React Native, Expo and consumed a Chat-GPT API Endpoint from OpenAI.",
    imageUrl: haileysbot,
    url: "https://github.com/Anthony-eng21/Tony-s-chatbot",
  },
  {
    title: "RapNow!",
    description:
      "Fun way to improve your rap skills! Timed beat selection, catalog of shuffled beats to freestyle with. Built with React Native, Expo and SQLite.",
    imageUrl: RapNow,
    url: "https://github.com/Anthony-eng21/RapNowV1",
  },
];
